import { createAsyncThunk, createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { jsonGet } from '../api';
import { Territory } from '../models/territories';

type SliceModel = Territory;
const sliceName: string = 'territories';

const currRequests: Set<ModelId> = new Set;

export const fetchTerritory = createAsyncThunk(
    sliceName + '/fetchById',
    async (id: ModelId) => {
        if (currRequests.has(id)) {
            return null;
        } else {
            currRequests.add(id);
            return await jsonGet<SliceModel>('/data/' + sliceName + '/' + id);
        }
    }
);

export const territoryAdapter = createEntityAdapter<SliceModel>({
    selectId: (attrs: SliceModel) => attrs.id
});
export const territorySlice = createSlice({
    name: sliceName,
    initialState: territoryAdapter.getInitialState(),
    reducers: {
        addMany: territoryAdapter.addMany,
        addOne: territoryAdapter.addOne,
        updateMany: territoryAdapter.updateMany,
        updateOne: territoryAdapter.updateOne,
        upsertOne: territoryAdapter.upsertOne,
        upsertMany: territoryAdapter.upsertMany,
        removeOne: territoryAdapter.removeOne
    },
    extraReducers: (builder) => {
        // Add reducers for additional action types here, and handle loading state as needed
        builder.addCase(fetchTerritory.fulfilled, (state, action) => {
            if (action.payload) {
                currRequests.delete(action.payload.id);
                territoryAdapter.upsertOne(state, action.payload);
            }
        });
    },
});
